import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M22.25 4C19.669 4 17.409 5.11 16 6.986 14.591 5.11 12.331 4 9.75 4a7.84 7.84 0 0 0-5.478 2.272A7.7 7.7 0 0 0 1.98 11.75c0 8.75 12.994 15.833 13.546 16.125a1 1 0 0 0 .948 0c.552-.292 13.546-7.375 13.546-16.125a7.7 7.7 0 0 0-2.293-5.478A7.84 7.84 0 0 0 22.25 4M16 25.85c-2.283-1.33-12-7.389-12-14.1A5.757 5.757 0 0 1 9.75 6c2.431 0 4.473 1.295 5.325 3.375a1 1 0 0 0 1.85 0C17.777 7.291 19.819 6 22.25 6A5.76 5.76 0 0 1 28 11.75c0 6.701-9.72 12.769-12 14.1"
    />
  </svg>
);
const SvgIconLove = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconLove);
export default Memo;
